import lang from "@/views/modules/ReviewerDocuments/language/en";

let searchFieldsDef = {
    'date_entered': {
        type:'date',
        label: lang.LBL_UPLOAD_DATE,
    },
    'application_title': {
        label: lang.LBL_APPLICATION_TITLE,
        relRef: 'reviewerdocuments_applications',
    },
    'created_by': {
        label: lang.LBL_UPLOAD_BY,
        type:'selectcomponent',
        route: 'users',
        moduleName: 'Users',
        name: 'document_user_name',
        id: 'document_created_by',
    },
};
export default { searchFieldsDef }